import { SessionIASMA } from 'iasma-datatypes';
import pkg from '../package.json';

export const CURRENT_VERSION = pkg.version;
console.log("CURRENT_VERSION", CURRENT_VERSION);

export const SESSION_NAME = 'iasma_session';

// Production of IASMA-API
const DOMAIN_PROD = `https://${window.location.hostname}`

// Test with production IASMA-API
// const DOMAIN_DEVL = 'https://iasma.id'

// Development IASMA-API
const DOMAIN_DEVL = 'http://localhost:8573'

export const DOMAIN_API = import.meta.env.PROD ? DOMAIN_PROD : DOMAIN_DEVL

export function getExpiredInfo(expiredDate: string | undefined) {
	if (!expiredDate) return "Expired!";

	var expired: Date = new Date(expiredDate);
	var now: Date = new Date();

	var diff = expired.getTime() - now.getTime();
	if (diff < 1000 * 60)
		return "expired in " + Math.floor(diff / 1000) + " seconds";
	if (diff < 1000 * 60 * 60)
		return "expired in " + Math.floor(diff / 1000 / 60) + " minutes";
	if (diff < 1000 * 60 * 60 * 24)
		return "expired in " + Math.floor(diff / 1000 / 60 / 60) + " hours";
	// if (diff < 1000 * 60 * 60 * 24 * 30)
	return "expired in " + Math.floor(diff / 1000 / 60 / 60 / 24) + " days";
}

export const JobCategories = [
	"Swasta",
	"Kesehatan",
	"Pendidikan",
	"Finansial",
	"Pemerintahan",
	"Hankam",
	"Pengadilan",
	"Pertambangan",
	"Lainnya"
];

export const JobSpecialties: Record<string, string[]> = {
	Swasta: ['Dagang', 'Petani', 'Jasa', 'Lainnya'],
	Kesehatan: ['Dokter','Perawat', 'Farmasi', 'Bidan', 'Lainnya'],
	Pendidikan: ['Dosen', 'Guru', 'Peneliti', 'Lainnya'],
	IT: ['Software Development', 'Security', 'Operational', 'UI/UX Design', 'Networking'],
	Pemerintahan: ['PNS', 'Gubernur', 'Bupati/Walikota', 'Camat', 'Lurah/Kepdes', 'Lainnya'],
	Hankam: ['TNI-AD', 'TNI-AL', 'TNI-AU', 'Polri', 'Hansip', 'Lainnya'],
	Pengadilan: ['Hakim', 'Jaksa', 'Pengacara'],
	Finansial: ['Perbankan', 'Lainnya'],
	Pertambangan: ['Oil & Gas', 'Batubara', 'Mineral', 'Lainnya'],
	Lainnya: ["Lainnya"]
};

export const INDONESIA = 'Indonesia';

export function GenderName(g: string | undefined): string {
	switch (g) {
	case "L": return "Laki-laki"
	case "P": return "Perempuan"
	default: return "-"
	}
}

export function ReligionName(r: string | undefined): string {
	switch (r) {
	case "I": return "Islam"
	case "K": return "Kristen"
	case "H": return "Hindu"
	case "B": return "Budha"
	case "O": return "Lainnya"
	default: return "-"
	}
}

export const IndonesiaData: Record<string, string[]> = {
	'Aceh': ['Banda Aceh', 'Langsa', 'Lhokseumawe', 'Sabang', 'Subulussalam', 'Aceh Barat', 'Aceh Besar', 'Aceh Selatan', 'Aceh Timur'],
	'Sumatera Utara': ['Medan', 'Binjai', 'Pematangsiantar', 'Tebing Tinggi', 'Deli Serdang', 'Karo', 'Langkat', 'Simalungun', 'Toba'],
	'Sumatera Barat': ['Padang', 'Bukittinggi', 'Padang Panjang', 'Payakumbuh', 'Solok', 'Agam', 'Pasaman', 'Tanah Datar'],
	'Riau': ['Pekanbaru', 'Dumai', 'Bengkalis', 'Indragiri Hilir', 'Kampar', 'Pelalawan', 'Rokan Hilir', 'Siak'],
	'Kepulauan Riau': ['Batam', 'Tanjung Pinang', 'Bintan', 'Karimun', 'Lingga', 'Natuna'],
	'Jambi': ['Jambi', 'Sungai Penuh', 'Batang Hari', 'Bungo', 'Kerinci', 'Merangin', 'Muaro Jambi', 'Tebo'],
	'Sumatera Selatan': ['Palembang', 'Lubuklinggau', 'Pagar Alam', 'Prabumulih', 'Banyuasin', 'Empat Lawang', 'Lahat', 'Muara Enim'],
	'Kepulauan Bangka Belitung': ['Pangkal Pinang', 'Bangka', 'Bangka Barat', 'Bangka Selatan', 'Bangka Tengah', 'Belitung', 'Belitung Timur'],
	'Bengkulu': ['Bengkulu', 'Bengkulu Selatan', 'Bengkulu Tengah', 'Bengkulu Utara', 'Kaur', 'Kepahiang', 'Lebong', 'Mukomuko', 'Rejang Lebong', 'Seluma'],
	'Lampung': ['Bandar Lampung', 'Metro', 'Lampung Barat', 'Lampung Selatan', 'Lampung Tengah', 'Lampung Timur', 'Lampung Utara', 'Pesawaran', 'Tanggamus', 'Tulang Bawang'],
	'DKI Jakarta': ['Jakarta Pusat', 'Jakarta Utara', 'Jakarta Barat', 'Jakarta Selatan', 'Jakarta Timur', 'Kepulauan Seribu'],
	'Jawa Barat': ['Bandung', 'Bekasi', 'Bogor', 'Cimahi', 'Cirebon', 'Depok', 'Sukabumi', 'Tasikmalaya', 'Bandung Barat', 'Cianjur', 'Garut', 'Indramayu', 'Karawang', 'Kuningan', 'Majalengka', 'Pangandaran', 'Purwakarta', 'Subang', 'Sumedang'],
	'Banten': ['Tangerang', 'Tangerang Selatan', 'Serang', 'Cilegon', 'Lebak', 'Pandeglang'],
	'Jawa Tengah': ['Semarang', 'Magelang', 'Pekalongan', 'Salatiga', 'Surakarta', 'Tegal', 'Banjarnegara', 'Banyumas', 'Batang', 'Blora', 'Boyolali', 'Brebes', 'Cilacap', 'Demak', 'Grobogan', 'Jepara', 'Karanganyar', 'Kebumen', 'Kendal', 'Klaten', 'Kudus', 'Pati', 'Pemalang', 'Purbalingga', 'Purworejo', 'Rembang', 'Sragen', 'Sukoharjo', 'Temanggung', 'Wonogiri', 'Wonosobo'],
	'DI Yogyakarta': ['Yogyakarta', 'Bantul', 'Gunung Kidul', 'Kulon Progo', 'Sleman'],
	'Jawa Timur': ['Surabaya', 'Malang', 'Batu', 'Blitar', 'Kediri', 'Madiun', 'Mojokerto', 'Pasuruan', 'Probolinggo', 'Bangkalan', 'Banyuwangi', 'Bojonegoro', 'Bondowoso', 'Gresik', 'Jember', 'Jombang', 'Lamongan', 'Lumajang', 'Magetan', 'Nganjuk', 'Ngawi', 'Pacitan', 'Pamekasan', 'Ponorogo', 'Sampang', 'Sidoarjo', 'Situbondo', 'Sumenep', 'Trenggalek', 'Tuban', 'Tulungagung'],
	'Bali': ['Denpasar', 'Badung', 'Bangli', 'Buleleng', 'Gianyar', 'Jembrana', 'Karangasem', 'Klungkung', 'Tabanan'],
	'Nusa Tenggara Barat': ['Mataram', 'Bima', 'Bima', 'Dompu', 'Lombok Barat', 'Lombok Tengah', 'Lombok Timur', 'Lombok Utara', 'Sumbawa', 'Sumbawa Barat'],
	'Nusa Tenggara Timur': ['Kupang', 'Alor', 'Belu', 'Ende', 'Flores Timur', 'Kupang', 'Lembata', 'Manggarai', 'Ngada', 'Rote Ndao', 'Sikka', 'Sumba Barat', 'Sumba Timur', 'Timor Tengah Selatan', 'Timor Tengah Utara'],
	'Kalimantan Barat': ['Pontianak', 'Singkawang', 'Bengkayang', 'Kapuas Hulu', 'Kayong Utara', 'Ketapang', 'Kubu Raya', 'Landak', 'Melawi', 'Sambas', 'Sanggau', 'Sekadau', 'Sintang'],
	'Kalimantan Tengah': ['Palangka Raya', 'Barito Selatan', 'Barito Timur', 'Barito Utara', 'Gunung Mas', 'Kapuas', 'Katingan', 'Kotawaringin Barat', 'Kotawaringin Timur', 'Lamandau', 'Murung Raya', 'Pulang Pisau', 'Seruyan', 'Sukamara'],
	'Kalimantan Selatan': ['Banjarmasin', 'Banjarbaru', 'Balangan', 'Banjar', 'Barito Kuala', 'Hulu Sungai Selatan', 'Hulu Sungai Tengah', 'Hulu Sungai Utara', 'Kotabaru', 'Tabalong', 'Tanah Bumbu', 'Tanah Laut', 'Tapin'],
	'Kalimantan Timur': ['Samarinda', 'Balikpapan', 'Bontang', 'Berau', 'Kutai Barat', 'Kutai Kartanegara', 'Kutai Timur', 'Mahakam Ulu', 'Paser', 'Penajam Paser Utara'],
	'Kalimantan Utara': ['Tarakan', 'Bulungan', 'Malinau', 'Nunukan', 'Tana Tidung'],
	'Sulawesi Utara': ['Manado', 'Bitung', 'Kotamobagu', 'Tomohon', 'Bolaang Mongondow', 'Kepulauan Sangihe', 'Kepulauan Talaud', 'Minahasa', 'Minahasa Selatan', 'Minahasa Tenggara', 'Minahasa Utara'],
	'Gorontalo': ['Gorontalo', 'Boalemo', 'Bone Bolango', 'Gorontalo', 'Gorontalo Utara', 'Pohuwato'],
	'Sulawesi Tengah': ['Palu', 'Banggai', 'Banggai Kepulauan', 'Buol', 'Donggala', 'Morowali', 'Parigi Moutong', 'Poso', 'Sigi', 'Tojo Una-Una', 'Toli-Toli'],
	'Sulawesi Barat': ['Mamuju', 'Majene', 'Mamasa', 'Mamuju Tengah', 'Pasangkayu', 'Polewali Mandar'],
	'Sulawesi Selatan': ['Makassar', 'Palopo', 'Parepare', 'Bantaeng', 'Barru', 'Bone', 'Bulukumba', 'Enrekang', 'Gowa', 'Jeneponto', 'Kepulauan Selayar', 'Luwu', 'Luwu Timur', 'Luwu Utara', 'Maros', 'Pangkajene dan Kepulauan', 'Pinrang', 'Sidenreng Rappang', 'Sinjai', 'Soppeng', 'Takalar', 'Tana Toraja', 'Toraja Utara', 'Wajo'],
	'Sulawesi Tenggara': ['Kendari', 'Bau-Bau', 'Bombana', 'Buton', 'Buton Utara', 'Kolaka', 'Kolaka Utara', 'Konawe', 'Konawe Selatan', 'Konawe Utara', 'Muna', 'Wakatobi'],
	'Maluku': ['Ambon', 'Tual', 'Buru', 'Buru Selatan', 'Kepulauan Aru', 'Maluku Barat Daya', 'Maluku Tengah', 'Maluku Tenggara', 'Maluku Tenggara Barat', 'Seram Bagian Barat', 'Seram Bagian Timur'],
	'Maluku Utara': ['Ternate', 'Tidore Kepulauan', 'Halmahera Barat', 'Halmahera Selatan', 'Halmahera Tengah', 'Halmahera Timur', 'Halmahera Utara', 'Kepulauan Sula', 'Pulau Morotai'],
	'Papua Barat': ['Manokwari', 'Sorong', 'Fakfak', 'Kaimana', 'Manokwari Selatan', 'Maybrat', 'Pegunungan Arfak', 'Raja Ampat', 'Sorong Selatan', 'Tambrauw', 'Teluk Bintuni', 'Teluk Wondama'],
	'Papua': ['Jayapura', 'Asmat', 'Biak Numfor', 'Boven Digoel', 'Deiyai', 'Dogiyai', 'Intan Jaya', 'Jayapura', 'Jayawijaya', 'Keerom', 'Kepulauan Yapen', 'Lanny Jaya', 'Mamberamo Raya', 'Mamberamo Tengah', 'Mappi', 'Merauke', 'Mimika', 'Nabire', 'Nduga', 'Paniai', 'Pegunungan Bintang', 'Puncak', 'Puncak Jaya', 'Sarmi', 'Supiori', 'Tolikara', 'Waropen', 'Yahukimo', 'Yalimo']
};


export const IconTombStone = ({ className = "" }: { className?: string }) => (
	<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"  className="w-3 h-3 mx-2 text-slate-500">
		<g id="SVGRepo_bgCarrier" stroke-width="0"></g>
		<g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
		<g id="SVGRepo_iconCarrier"> 
			<path d="M19 21V10C19 6.13401 15.866 3 12 3C8.13401 3 5 6.13401 5 10V21M3 21H21" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> 
		</g>
	</svg>
);

export const IconLucideCircleDashedCheck = ({ className = "", size = 24 }: { 
	className?: string 
	size?: number
}) => (
	<svg xmlns="http://www.w3.org/2000/svg" 
		width={`"${size}"`} height={`"${size}"`} viewBox={`"0 0 ${size} ${size}"`} 
		fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" 		
		className={`lucide lucide-circle-dashed-check preview-icon ${className}`}>
			<path d="M10.1 2.182a10 10 0 013.8 0"/>
			<path d="M13.9 21.818a10 10 0 01-3.8 0"/>
			<path d="m16 9-5.5 5.5L8 12"/>
			<path d="M17.609 3.721a10 10 0 012.69 2.7"/>
			<path d="M2.182 13.9a10 10 0 010-3.8"/>
			<path d="M20.279 17.609a10 10 0 01-2.7 2.69"/>
			<path d="M21.818 10.1a10 10 0 010 3.8"/>
			<path d="M3.721 6.391a10 10 0 012.7-2.69"/>
			<path d="M6.391 20.279a10 10 0 01-2.69-2.7"/>
		</svg>
);

export function getLocalTime() {
	var date = new Date();
	var today = new Date(date.getTime() - (date.getTimezoneOffset() * 60000)).toISOString().replace(/T/, ' ').slice(0, -5); // avoid dot in json key name
	return today;
}